export default __webpack_public_path__ + "static/media/nfeIcon.f95e0eb2.svg";